export default __webpack_public_path__ + "static/media/homeHeaderBannerMobile.19714e0c.png";